import { Injectable, OnDestroy } from '@angular/core';
import { GuardResult, RedirectCommand, Route, Router, UrlSegment } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { UserLevels } from '../shared/globals';
import { Tree } from '../shared/models/tree.model';
import { TreeService } from '../shared/services/tree.service';

@Injectable({
  providedIn: 'root'
})
export class TreeSettingsGuard implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private router: Router, private treeService: TreeService) { }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  /**
   * canMatch, a nie canLoad: canLoad sprawdza sie tylko wtedy, gdy modul nie
   * jest jeszcze wczytany, wiec po jednym wejsciu administratora zostawal
   * pominiety do konca zycia karty - wystarczylo wylogowac sie i zalogowac
   * jako zwykly uzytkownik. canMatch dziala przy kazdej nawigacji.
   */
  canMatch(route: Route, segments: UrlSegment[]): Observable<GuardResult> {
    const treeUrl = segments[1]?.path ?? '';
    const attempted = '/' + segments.map(segment => segment.path).join('/');
    return this.treeService.setCurrentTreeByUrl(treeUrl)
      .pipe(takeUntil(this.ngUnsubscribe), map(result => {
        if (result instanceof Tree
          && (result.membershiplevel === UserLevels.Administrator
            || result.membershiplevel === UserLevels.SuperAdministrator)) {
          return true;
        }
        // Poziom 0 znaczy, ze serwer widzi goscia - najczesciej po wygasnieciu
        // sesji, bo przycisk "Ustawienia drzewa" zna tylko poziom zapamietany
        // w przegladarce. Odroznienie od "zalogowany, ale bez uprawnien"
        // decyduje o tresci komunikatu.
        const reason = result instanceof Tree
          ? (result.membershiplevel > UserLevels.None ? 'admin' : 'signin')
          : 'private';
        const target = this.router.createUrlTree(['/tree', treeUrl, 'notauthorized'],
          { queryParams: { reason, from: attempted } });
        // RedirectCommand ze skipLocationChange: komunikat pokazuje sie ZAMIAST
        // zadanej strony, a w pasku zostaje jej adres - odswiezenie po
        // zalogowaniu prowadzi tam, gdzie uzytkownik chcial trafic
        return new RedirectCommand(target, { skipLocationChange: true });
      }));
  }
}
